"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __values = this && this.__values || function (o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // tslint:disable:no-consecutive-blank-lines ordered-imports align trailing-comma enum-naming
// tslint:disable:whitespace no-unbound-method no-trailing-whitespace
// tslint:disable:no-unused-variable

var base_contract_1 = require("@0x/base-contract");

var json_schemas_1 = require("@0x/json-schemas");

var utils_1 = require("@0x/utils");

var web3_wrapper_1 = require("@0x/web3-wrapper");

var assert_1 = require("@0x/assert");

var ethers = require("ethers");

var ERC721TokenEvents;

(function (ERC721TokenEvents) {
  ERC721TokenEvents["Approval"] = "Approval";
  ERC721TokenEvents["ApprovalForAll"] = "ApprovalForAll";
  ERC721TokenEvents["Transfer"] = "Transfer";
})(ERC721TokenEvents = exports.ERC721TokenEvents || (exports.ERC721TokenEvents = {}));
/* istanbul ignore next */
// tslint:disable:no-parameter-reassignment
// tslint:disable-next-line:class-name


var ERC721TokenContract =
/** @class */
function (_super) {
  __extends(ERC721TokenContract, _super);

  function ERC721TokenContract(address, supportedProvider, txDefaults, logDecodeDependencies, deployedBytecode) {
    if (deployedBytecode === void 0) {
      deployedBytecode = ERC721TokenContract.deployedBytecode;
    }

    var _this = _super.call(this, 'ERC721Token', ERC721TokenContract.ABI(), address, supportedProvider, txDefaults, logDecodeDependencies, deployedBytecode) || this;

    _this._methodABIIndex = {};
    utils_1.classUtils.bindAll(_this, ['_abiEncoderByFunctionSignature', 'address', '_web3Wrapper']);
    _this._subscriptionManager = new base_contract_1.SubscriptionManager(ERC721TokenContract.ABI(), _this._web3Wrapper);
    ERC721TokenContract.ABI().forEach(function (item, index) {
      if (item.type === 'function') {
        var methodAbi = item;
        _this._methodABIIndex[methodAbi.name] = index;
      }
    });
    return _this;
  }

  ERC721TokenContract.deployFrom0xArtifactAsync = function (artifact, supportedProvider, txDefaults, logDecodeDependencies) {
    return __awaiter(this, void 0, void 0, function () {
      var e_1, _a, provider, bytecode, abi, logDecodeDependenciesAbiOnly, _b, _c, key;

      return __generator(this, function (_d) {
        assert_1.assert.doesConformToSchema('txDefaults', txDefaults, json_schemas_1.schemas.txDataSchema, [json_schemas_1.schemas.addressSchema, json_schemas_1.schemas.numberSchema, json_schemas_1.schemas.jsNumber]);

        if (artifact.compilerOutput === undefined) {
          throw new Error('Compiler output not found in the artifact file');
        }

        provider = utils_1.providerUtils.standardizeOrThrow(supportedProvider);
        bytecode = artifact.compilerOutput.evm.bytecode.object;
        abi = artifact.compilerOutput.abi;
        logDecodeDependenciesAbiOnly = {};

        if (Object.keys(logDecodeDependencies) !== undefined) {
          try {
            for (_b = __values(Object.keys(logDecodeDependencies)), _c = _b.next(); !_c.done; _c = _b.next()) {
              key = _c.value;
              logDecodeDependenciesAbiOnly[key] = logDecodeDependencies[key].compilerOutput.abi;
            }
          } catch (e_1_1) {
            e_1 = {
              error: e_1_1
            };
          } finally {
            try {
              if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
        }

        return [2
        /*return*/
        , ERC721TokenContract.deployAsync(bytecode, abi, provider, txDefaults, logDecodeDependenciesAbiOnly)];
      });
    });
  };

  ERC721TokenContract.deployAsync = function (bytecode, abi, supportedProvider, txDefaults, logDecodeDependencies) {
    return __awaiter(this, void 0, void 0, function () {
      var provider, constructorAbi, iface, deployInfo, txData, web3Wrapper, txDataWithDefaults, txHash, txReceipt, contractInstance;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            assert_1.assert.isHexString('bytecode', bytecode);
            assert_1.assert.doesConformToSchema('txDefaults', txDefaults, json_schemas_1.schemas.txDataSchema, [json_schemas_1.schemas.addressSchema, json_schemas_1.schemas.numberSchema, json_schemas_1.schemas.jsNumber]);
            provider = utils_1.providerUtils.standardizeOrThrow(supportedProvider);
            constructorAbi = base_contract_1.BaseContract._lookupConstructorAbi(abi);

            base_contract_1.BaseContract._formatABIDataItemList(constructorAbi.inputs, [], base_contract_1.BaseContract._bigNumberToString);

            iface = new ethers.utils.Interface(abi);
            deployInfo = iface.deployFunction;
            txData = deployInfo.encode(bytecode, []);
            web3Wrapper = new web3_wrapper_1.Web3Wrapper(provider);
            return [4
            /*yield*/
            , base_contract_1.BaseContract._applyDefaultsToContractTxDataAsync(__assign({
              data: txData
            }, txDefaults), web3Wrapper.estimateGasAsync.bind(web3Wrapper))];

          case 1:
            txDataWithDefaults = _a.sent();
            return [4
            /*yield*/
            , web3Wrapper.sendTransactionAsync(txDataWithDefaults)];

          case 2:
            txHash = _a.sent();
            utils_1.logUtils.log("transactionHash: " + txHash);
            return [4
            /*yield*/
            , web3Wrapper.awaitTransactionSuccessAsync(txHash)];

          case 3:
            txReceipt = _a.sent();
            utils_1.logUtils.log("ERC721Token successfully deployed at " + txReceipt.contractAddress);
            contractInstance = new ERC721TokenContract(txReceipt.contractAddress, provider, txDefaults, logDecodeDependencies);
            contractInstance.constructorArgs = [];
            return [2
            /*return*/
            , contractInstance];
        }
      });
    });
  };
  /**
   * @returns      The contract ABI
   */


  ERC721TokenContract.ABI = function () {
    var abi = [{
      anonymous: false,
      inputs: [{
        name: '_owner',
        type: 'address',
        indexed: true
      }, {
        name: '_approved',
        type: 'address',
        indexed: true
      }, {
        name: '_tokenId',
        type: 'uint256',
        indexed: true
      }],
      name: 'Approval',
      outputs: [],
      type: 'event'
    }, {
      anonymous: false,
      inputs: [{
        name: '_owner',
        type: 'address',
        indexed: true
      }, {
        name: '_operator',
        type: 'address',
        indexed: true
      }, {
        name: '_approved',
        type: 'bool',
        indexed: false
      }],
      name: 'ApprovalForAll',
      outputs: [],
      type: 'event'
    }, {
      anonymous: false,
      inputs: [{
        name: '_from',
        type: 'address',
        indexed: true
      }, {
        name: '_to',
        type: 'address',
        indexed: true
      }, {
        name: '_tokenId',
        type: 'uint256',
        indexed: true
      }],
      name: 'Transfer',
      outputs: [],
      type: 'event'
    }, {
      constant: false,
      inputs: [{
        name: '_approved',
        type: 'address'
      }, {
        name: '_tokenId',
        type: 'uint256'
      }],
      name: 'approve',
      outputs: [],
      payable: false,
      stateMutability: 'nonpayable',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: '_owner',
        type: 'address'
      }],
      name: 'balanceOf',
      outputs: [{
        name: '',
        type: 'uint256'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: '_tokenId',
        type: 'uint256'
      }],
      name: 'getApproved',
      outputs: [{
        name: '',
        type: 'address'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: '_owner',
        type: 'address'
      }, {
        name: '_operator',
        type: 'address'
      }],
      name: 'isApprovedForAll',
      outputs: [{
        name: '',
        type: 'bool'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: '_tokenId',
        type: 'uint256'
      }],
      name: 'ownerOf',
      outputs: [{
        name: '',
        type: 'address'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: false,
      inputs: [{
        name: '_from',
        type: 'address'
      }, {
        name: '_to',
        type: 'address'
      }, {
        name: '_tokenId',
        type: 'uint256'
      }],
      name: 'safeTransferFrom',
      outputs: [],
      payable: false,
      stateMutability: 'nonpayable',
      type: 'function'
    }, {
      constant: false,
      inputs: [{
        name: '_from',
        type: 'address'
      }, {
        name: '_to',
        type: 'address'
      }, {
        name: '_tokenId',
        type: 'uint256'
      }, {
        name: '_data',
        type: 'bytes'
      }],
      name: 'safeTransferFrom',
      outputs: [],
      payable: false,
      stateMutability: 'nonpayable',
      type: 'function'
    }, {
      constant: false,
      inputs: [{
        name: '_operator',
        type: 'address'
      }, {
        name: '_approved',
        type: 'bool'
      }],
      name: 'setApprovalForAll',
      outputs: [],
      payable: false,
      stateMutability: 'nonpayable',
      type: 'function'
    }, {
      constant: false,
      inputs: [{
        name: '_from',
        type: 'address'
      }, {
        name: '_to',
        type: 'address'
      }, {
        name: '_tokenId',
        type: 'uint256'
      }],
      name: 'transferFrom',
      outputs: [],
      payable: false,
      stateMutability: 'nonpayable',
      type: 'function'
    }];
    return abi;
  };

  ERC721TokenContract.prototype.getFunctionSignature = function (methodName) {
    var index = this._methodABIIndex[methodName];
    var methodAbi = ERC721TokenContract.ABI()[index]; // tslint:disable-line:no-unnecessary-type-assertion

    var functionSignature = base_contract_1.methodAbiToFunctionSignature(methodAbi);
    return functionSignature;
  };

  ERC721TokenContract.prototype.getABIDecodedTransactionData = function (methodName, callData) {
    var functionSignature = this.getFunctionSignature(methodName);
    var self = this;

    var abiEncoder = self._lookupAbiEncoder(functionSignature);

    var abiDecodedCallData = abiEncoder.strictDecode(callData);
    return abiDecodedCallData;
  };

  ERC721TokenContract.prototype.getABIDecodedReturnData = function (methodName, callData) {
    var functionSignature = this.getFunctionSignature(methodName);
    var self = this;

    var abiEncoder = self._lookupAbiEncoder(functionSignature);

    var abiDecodedCallData = abiEncoder.strictDecodeReturnValue(callData);
    return abiDecodedCallData;
  };

  ERC721TokenContract.prototype.getSelector = function (methodName) {
    var functionSignature = this.getFunctionSignature(methodName);
    var self = this;

    var abiEncoder = self._lookupAbiEncoder(functionSignature);

    return abiEncoder.getSelector();
  };
  /**
   * The zero address indicates there is no approved address.
   * Throws unless `msg.sender` is the current NFT owner, or an authorized
   * operator of the current owner.
   * @param _approved The new approved NFT controller
   * @param _tokenId The NFT to approve
   */


  ERC721TokenContract.prototype.approve = function (_approved, _tokenId) {
    var self = this;
    assert_1.assert.isString('_approved', _approved);
    assert_1.assert.isBigNumber('_tokenId', _tokenId);
    var functionSignature = 'approve(address,uint256)';
    return {
      sendTransactionAsync: function sendTransactionAsync(txData, opts) {
        if (opts === void 0) {
          opts = {
            shouldValidate: true
          };
        }

        return __awaiter(this, void 0, void 0, function () {
          var txDataWithDefaults;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , self._applyDefaultsToTxDataAsync(__assign({}, txData, {
                  data: this.getABIEncodedTransactionData()
                }), this.estimateGasAsync.bind(this))];

              case 1:
                txDataWithDefaults = _a.sent();
                if (!(opts.shouldValidate !== false)) return [3
                /*break*/
                , 3];
                return [4
                /*yield*/
                , this.callAsync(txDataWithDefaults)];

              case 2:
                _a.sent();

                _a.label = 3;

              case 3:
                return [2
                /*return*/
                , self._web3Wrapper.sendTransactionAsync(txDataWithDefaults)];
            }
          });
        });
      },
      awaitTransactionSuccessAsync: function awaitTransactionSuccessAsync(txData, opts) {
        if (opts === void 0) {
          opts = {
            shouldValidate: true
          };
        }

        return self._promiseWithTransactionHash(this.sendTransactionAsync(txData, opts), opts);
      },
      estimateGasAsync: function estimateGasAsync(txData) {
        return __awaiter(this, void 0, void 0, function () {
          var txDataWithDefaults;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , self._applyDefaultsToTxDataAsync(__assign({}, txData, {
                  data: this.getABIEncodedTransactionData()
                }))];

              case 1:
                txDataWithDefaults = _a.sent();
                return [2
                /*return*/
                , self._web3Wrapper.estimateGasAsync(txDataWithDefaults)];
            }
          });
        });
      },
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);
                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [_approved.toLowerCase(), _tokenId]);
      }
    };
  };
  /**
   * NFTs assigned to the zero address are considered invalid, and this
   * function throws for queries about the zero address.
   * @param _owner An address for whom to query the balance
   * @returns The number of NFTs owned by &#x60;_owner&#x60;, possibly zero
   */


  ERC721TokenContract.prototype.balanceOf = function (_owner) {
    var self = this;
    assert_1.assert.isString('_owner', _owner);
    var functionSignature = 'balanceOf(address)';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);
                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [_owner.toLowerCase()]);
      }
    };
  };
  /**
   * Throws if `_tokenId` is not a valid NFT.
   * @param _tokenId The NFT to find the approved address for
   * @returns The approved address for this NFT, or the zero address if there is none
   */


  ERC721TokenContract.prototype.getApproved = function (_tokenId) {
    var self = this;
    assert_1.assert.isBigNumber('_tokenId', _tokenId);
    var functionSignature = 'getApproved(uint256)';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);
                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [_tokenId]);
      }
    };
  };

  ERC721TokenContract.prototype.isApprovedForAll = function (_owner, _operator) {
    var self = this;
    assert_1.assert.isString('_owner', _owner);
    assert_1.assert.isString('_operator', _operator);
    var functionSignature = 'isApprovedForAll(address,address)';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);
                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [_owner.toLowerCase(), _operator.toLowerCase()]);
      }
    };
  };
  /**
   * NFTs assigned to zero address are considered invalid, and queries
   * about them do throw.
   * @param _tokenId The identifier for an NFT
   * @returns The address of the owner of the NFT
   */


  ERC721TokenContract.prototype.ownerOf = function (_tokenId) {
    var self = this;
    assert_1.assert.isBigNumber('_tokenId', _tokenId);
    var functionSignature = 'ownerOf(uint256)';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);
                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [_tokenId]);
      }
    };
  };
  /**
   * This works identically to the other function with an extra data parameter,
   * except this function just sets data to "".
   * @param _from The current owner of the NFT
   * @param _to The new owner
   * @param _tokenId The NFT to transfer
   */


  ERC721TokenContract.prototype.safeTransferFrom1 = function (_from, _to, _tokenId) {
    var self = this;
    assert_1.assert.isString('_from', _from);
    assert_1.assert.isString('_to', _to);
    assert_1.assert.isBigNumber('_tokenId', _tokenId);
    var functionSignature = 'safeTransferFrom(address,address,uint256)';
    return {
      sendTransactionAsync: function sendTransactionAsync(txData, opts) {
        if (opts === void 0) {
          opts = {
            shouldValidate: true
          };
        }

        return __awaiter(this, void 0, void 0, function () {
          var txDataWithDefaults;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , self._applyDefaultsToTxDataAsync(__assign({}, txData, {
                  data: this.getABIEncodedTransactionData()
                }), this.estimateGasAsync.bind(this))];

              case 1:
                txDataWithDefaults = _a.sent();
                if (!(opts.shouldValidate !== false)) return [3
                /*break*/
                , 3];
                return [4
                /*yield*/
                , this.callAsync(txDataWithDefaults)];

              case 2:
                _a.sent();

                _a.label = 3;

              case 3:
                return [2
                /*return*/
                , self._web3Wrapper.sendTransactionAsync(txDataWithDefaults)];
            }
          });
        });
      },
      awaitTransactionSuccessAsync: function awaitTransactionSuccessAsync(txData, opts) {
        if (opts === void 0) {
          opts = {
            shouldValidate: true
          };
        }

        return self._promiseWithTransactionHash(this.sendTransactionAsync(txData, opts), opts);
      },
      estimateGasAsync: function estimateGasAsync(txData) {
        return __awaiter(this, void 0, void 0, function () {
          var txDataWithDefaults;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , self._applyDefaultsToTxDataAsync(__assign({}, txData, {
                  data: this.getABIEncodedTransactionData()
                }))];

              case 1:
                txDataWithDefaults = _a.sent();
                return [2
                /*return*/
                , self._web3Wrapper.estimateGasAsync(txDataWithDefaults)];
            }
          });
        });
      },
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);
                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [_from.toLowerCase(), _to.toLowerCase(), _tokenId]);
      }
    };
  };
  /**
   * Throws unless `msg.sender` is the current owner, an authorized
   * operator, or the approved address for this NFT. Throws if `_from` is
   * not the current owner. Throws if `_to` is the zero address. Throws if
   * `_tokenId` is not a valid NFT. When transfer is complete, this function
   * checks if `_to` is a smart contract (code size > 0). If so, it calls
   * `onERC721Received` on `_to` and throws if the return value is not
   * `bytes4(keccak256("onERC721Received(address,address,uint256,bytes)"))`.
   * @param _from The current owner of the NFT
   * @param _to The new owner
   * @param _tokenId The NFT to transfer
   * @param _data Additional data with no specified format, sent in call to `_to`
   */


  ERC721TokenContract.prototype.safeTransferFrom2 = function (_from, _to, _tokenId, _data) {
    var self = this;
    assert_1.assert.isString('_from', _from);
    assert_1.assert.isString('_to', _to);
    assert_1.assert.isBigNumber('_tokenId', _tokenId);
    assert_1.assert.isString('_data', _data);
    var functionSignature = 'safeTransferFrom(address,address,uint256,bytes)';
    return {
      sendTransactionAsync: function sendTransactionAsync(txData, opts) {
        if (opts === void 0) {
          opts = {
            shouldValidate: true
          };
        }

        return __awaiter(this, void 0, void 0, function () {
          var txDataWithDefaults;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , self._applyDefaultsToTxDataAsync(__assign({}, txData, {
                  data: this.getABIEncodedTransactionData()
                }), this.estimateGasAsync.bind(this))];

              case 1:
                txDataWithDefaults = _a.sent();
                if (!(opts.shouldValidate !== false)) return [3
                /*break*/
                , 3];
                return [4
                /*yield*/
                , this.callAsync(txDataWithDefaults)];

              case 2:
                _a.sent();

                _a.label = 3;

              case 3:
                return [2
                /*return*/
                , self._web3Wrapper.sendTransactionAsync(txDataWithDefaults)];
            }
          });
        });
      },
      awaitTransactionSuccessAsync: function awaitTransactionSuccessAsync(txData, opts) {
        if (opts === void 0) {
          opts = {
            shouldValidate: true
          };
        }

        return self._promiseWithTransactionHash(this.sendTransactionAsync(txData, opts), opts);
      },
      estimateGasAsync: function estimateGasAsync(txData) {
        return __awaiter(this, void 0, void 0, function () {
          var txDataWithDefaults;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , self._applyDefaultsToTxDataAsync(__assign({}, txData, {
                  data: this.getABIEncodedTransactionData()
                }))];

              case 1:
                txDataWithDefaults = _a.sent();
                return [2
                /*return*/
                , self._web3Wrapper.estimateGasAsync(txDataWithDefaults)];
            }
          });
        });
      },
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);
                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [_from.toLowerCase(), _to.toLowerCase(), _tokenId, _data]);
      }
    };
  };
  /**
   * Emits the ApprovalForAll event. The contract MUST allow
   * multiple operators per owner.
   * @param _operator Address to add to the set of authorized operators
   * @param _approved True if the operator is approved, false to revoke approval
   */


  ERC721TokenContract.prototype.setApprovalForAll = function (_operator, _approved) {
    var self = this;
    assert_1.assert.isString('_operator', _operator);
    assert_1.assert.isBoolean('_approved', _approved);
    var functionSignature = 'setApprovalForAll(address,bool)';
    return {
      sendTransactionAsync: function sendTransactionAsync(txData, opts) {
        if (opts === void 0) {
          opts = {
            shouldValidate: true
          };
        }

        return __awaiter(this, void 0, void 0, function () {
          var txDataWithDefaults;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , self._applyDefaultsToTxDataAsync(__assign({}, txData, {
                  data: this.getABIEncodedTransactionData()
                }), this.estimateGasAsync.bind(this))];

              case 1:
                txDataWithDefaults = _a.sent();
                if (!(opts.shouldValidate !== false)) return [3
                /*break*/
                , 3];
                return [4
                /*yield*/
                , this.callAsync(txDataWithDefaults)];

              case 2:
                _a.sent();

                _a.label = 3;

              case 3:
                return [2
                /*return*/
                , self._web3Wrapper.sendTransactionAsync(txDataWithDefaults)];
            }
          });
        });
      },
      awaitTransactionSuccessAsync: function awaitTransactionSuccessAsync(txData, opts) {
        if (opts === void 0) {
          opts = {
            shouldValidate: true
          };
        }

        return self._promiseWithTransactionHash(this.sendTransactionAsync(txData, opts), opts);
      },
      estimateGasAsync: function estimateGasAsync(txData) {
        return __awaiter(this, void 0, void 0, function () {
          var txDataWithDefaults;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , self._applyDefaultsToTxDataAsync(__assign({}, txData, {
                  data: this.getABIEncodedTransactionData()
                }))];

              case 1:
                txDataWithDefaults = _a.sent();
                return [2
                /*return*/
                , self._web3Wrapper.estimateGasAsync(txDataWithDefaults)];
            }
          });
        });
      },
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);
                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [_operator.toLowerCase(), _approved]);
      }
    };
  };
  /**
   * Throws unless `msg.sender` is the current owner, an authorized
   * operator, or the approved address for this NFT. Throws if `_from` is
   * not the current owner. Throws if `_to` is the zero address. Throws if
   * `_tokenId` is not a valid NFT.
   * @param _from The current owner of the NFT
   * @param _to The new owner
   * @param _tokenId The NFT to transfer
   */


  ERC721TokenContract.prototype.transferFrom = function (_from, _to, _tokenId) {
    var self = this;
    assert_1.assert.isString('_from', _from);
    assert_1.assert.isString('_to', _to);
    assert_1.assert.isBigNumber('_tokenId', _tokenId);
    var functionSignature = 'transferFrom(address,address,uint256)';
    return {
      sendTransactionAsync: function sendTransactionAsync(txData, opts) {
        if (opts === void 0) {
          opts = {
            shouldValidate: true
          };
        }

        return __awaiter(this, void 0, void 0, function () {
          var txDataWithDefaults;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , self._applyDefaultsToTxDataAsync(__assign({}, txData, {
                  data: this.getABIEncodedTransactionData()
                }), this.estimateGasAsync.bind(this))];

              case 1:
                txDataWithDefaults = _a.sent();
                if (!(opts.shouldValidate !== false)) return [3
                /*break*/
                , 3];
                return [4
                /*yield*/
                , this.callAsync(txDataWithDefaults)];

              case 2:
                _a.sent();

                _a.label = 3;

              case 3:
                return [2
                /*return*/
                , self._web3Wrapper.sendTransactionAsync(txDataWithDefaults)];
            }
          });
        });
      },
      awaitTransactionSuccessAsync: function awaitTransactionSuccessAsync(txData, opts) {
        if (opts === void 0) {
          opts = {
            shouldValidate: true
          };
        }

        return self._promiseWithTransactionHash(this.sendTransactionAsync(txData, opts), opts);
      },
      estimateGasAsync: function estimateGasAsync(txData) {
        return __awaiter(this, void 0, void 0, function () {
          var txDataWithDefaults;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , self._applyDefaultsToTxDataAsync(__assign({}, txData, {
                  data: this.getABIEncodedTransactionData()
                }))];

              case 1:
                txDataWithDefaults = _a.sent();
                return [2
                /*return*/
                , self._web3Wrapper.estimateGasAsync(txDataWithDefaults)];
            }
          });
        });
      },
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);
                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [_from.toLowerCase(), _to.toLowerCase(), _tokenId]);
      }
    };
  };
  /**
   * Subscribe to an event type emitted by the ERC721Token contract.
   * @param eventName The ERC721Token contract event you would like to subscribe to.
   * @param indexFilterValues An object where the keys are indexed args returned by the event and
   * the value is the value you are interested in. E.g `{maker: aUserAddressHex}`
   * @param callback Callback that gets called when a log is added/removed
   * @param isVerbose Enable verbose subscription warnings (e.g recoverable network issues encountered)
   * @return Subscription token used later to unsubscribe
   */


  ERC721TokenContract.prototype.subscribe = function (eventName, indexFilterValues, callback, isVerbose, blockPollingIntervalMs) {
    if (isVerbose === void 0) {
      isVerbose = false;
    }

    assert_1.assert.doesBelongToStringEnum('eventName', eventName, ERC721TokenEvents);
    assert_1.assert.doesConformToSchema('indexFilterValues', indexFilterValues, json_schemas_1.schemas.indexFilterValuesSchema);
    assert_1.assert.isFunction('callback', callback);

    var subscriptionToken = this._subscriptionManager.subscribe(this.address, eventName, indexFilterValues, ERC721TokenContract.ABI(), callback, isVerbose, blockPollingIntervalMs);

    return subscriptionToken;
  };
  /**
   * Cancel a subscription
   * @param subscriptionToken Subscription token returned by `subscribe()`
   */


  ERC721TokenContract.prototype.unsubscribe = function (subscriptionToken) {
    this._subscriptionManager.unsubscribe(subscriptionToken);
  };
  /**
   * Cancels all existing subscriptions
   */


  ERC721TokenContract.prototype.unsubscribeAll = function () {
    this._subscriptionManager.unsubscribeAll();
  };
  /**
   * Gets historical logs without creating a subscription
   * @param eventName The ERC721Token contract event you would like to subscribe to.
   * @param blockRange Block range to get logs from.
   * @param indexFilterValues An object where the keys are indexed args returned by the event and
   * the value is the value you are interested in. E.g `{_from: aUserAddressHex}`
   * @return Array of logs that match the parameters
   */


  ERC721TokenContract.prototype.getLogsAsync = function (eventName, blockRange, indexFilterValues) {
    return __awaiter(this, void 0, void 0, function () {
      var logs;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            assert_1.assert.doesBelongToStringEnum('eventName', eventName, ERC721TokenEvents);
            assert_1.assert.doesConformToSchema('blockRange', blockRange, json_schemas_1.schemas.blockRangeSchema);
            assert_1.assert.doesConformToSchema('indexFilterValues', indexFilterValues, json_schemas_1.schemas.indexFilterValuesSchema);
            return [4
            /*yield*/
            , this._subscriptionManager.getLogsAsync(this.address, eventName, blockRange, indexFilterValues, ERC721TokenContract.ABI())];

          case 1:
            logs = _a.sent();
            return [2
            /*return*/
            , logs];
        }
      });
    });
  };

  ERC721TokenContract.contractName = 'ERC721Token';
  return ERC721TokenContract;
}(base_contract_1.BaseContract);

exports.ERC721TokenContract = ERC721TokenContract; // tslint:disable:max-file-line-count
// tslint:enable:no-unbound-method no-parameter-reassignment no-consecutive-blank-lines ordered-imports align
// tslint:enable:trailing-comma whitespace no-trailing-whitespace